import { TListingRoadblockConfigurationSet } from "./listingRoadblockTypesAndCodecs";
import { WinInstruction } from "./configurations/WinInstruction";
import { MarketPrepReady } from "./configurations/MarketPrepReady";
import { UnderOffer } from "./configurations/UnderOffer";
import { Completed } from "./configurations/Completed";

export const shListingRoadblockConfigs: TListingRoadblockConfigurationSet = [
    WinInstruction,
    MarketPrepReady,
    UnderOffer,
    Completed,
];
